// src/data/mockNotifications.ts
import { Notification } from '../types';

export const mockNotifications: Notification[] = [
  {
    id: 'n1',
    userId: 'u1',
    title: 'Nuevo documento subido',
    message: 'Acme Corp ha subido el documento "Código de Ética.pdf"',
    type: 'info',
    read: false,
    link: '/dashboard/documents',
    createdAt: '2025-11-05T14:30:00Z',
  },
  {
    id: 'n2',
    userId: 'u1',
    title: 'Tarea próxima a vencer',
    message: 'La tarea "Revisar hallazgos de auditoría Q4" vence en 2 días',
    type: 'warning',
    read: false,
    link: '/dashboard/tasks',
    createdAt: '2025-11-05T10:00:00Z',
  },
  {
    id: 'n3',
    userId: 'u1',
    title: 'Auditoría completada',
    message: 'La auditoría "Auditoría Contractual" ha sido marcada como completada',
    type: 'success',
    read: true,
    link: '/dashboard/audits',
    createdAt: '2025-11-04T16:45:00Z',
  },
  {
    id: 'n4',
    userId: 'u2',
    title: 'Nueva tarea asignada',
    message: 'Se te ha asignado la tarea "Subir reglamento interno actualizado"',
    type: 'info',
    read: false,
    link: '/dashboard/tasks',
    createdAt: '2025-11-05T09:15:00Z',
  },
  {
    id: 'n5',
    userId: 'u2',
    title: 'Tarea vencida',
    message: 'La tarea "Validar contratos laborales" ha vencido',
    type: 'error',
    read: false,
    link: '/dashboard/tasks',
    createdAt: '2025-11-05T08:00:00Z',
  },
  {
    id: 'n6',
    userId: 'u1',
    title: 'Nuevo usuario registrado',
    message: 'Se ha registrado un nuevo usuario: María López',
    type: 'info',
    read: true,
    link: '/dashboard/users',
    createdAt: '2025-11-03T11:20:00Z',
  },
];
